import { AnyAction } from 'redux';
import { handleActions, combineActions } from 'redux-actions';

import { getUnreadNotificationsAction } from '@reducers/shared/SharedActionConfig';

import {
  getMyClinicListAction,
  declineDentistInviteAction,
  acceptDentistInviteAction,

  updateMyClinicInvitesCountAction,
} from './DentistActionConfig';

// reducers
const defaultState = {
  myClinicInvites: 0,
  myClinicsData: {},
};

type State = typeof defaultState;

const reducer = handleActions<State, AnyAction>({
  [`${combineActions(declineDentistInviteAction, acceptDentistInviteAction)}`](state) {
    const newCount = state.myClinicInvites - 1;
    return {
      ...state,
      myClinicInvites: newCount,
    };
  },
  [`${getMyClinicListAction}`](state, { payload }: AnyAction) {
    return {
      ...state,
      myClinicsData: payload,
    };
  },
  [`${getUnreadNotificationsAction}`](state, { payload: rawPayload }: AnyAction) {
    // Phase 3 (backend): unread-notifications now answers {data: {...}} instead of it directly.
    const payload = rawPayload?.data ?? rawPayload;
    return {
      ...state,
      myClinicInvites: payload?.my_clinic_invites,
    };
  },
  [`${updateMyClinicInvitesCountAction}`](state) {
    const newCount = state.myClinicInvites + 1;
    return {
      ...state,
      myClinicInvites: newCount,
    };
  },
}, defaultState);

export default reducer;
